module.exports = __webpack_public_path__ + "assets/img/bg.e273bb0c.png";